import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 15px;

  .pagination {
    display: flex;
    list-style: none;
    user-select: none;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;

    & > * {
      margin-right: 10px;
    }

    & > *:last-child {
      margin-right: 0;
    }

    &__break {
      a {
        line-height: normal;
      }
    }
  }

  .pagination__page,
  .pagination__next,
  .pagination__prev {
    color: ${({ theme }) => theme.colors.gray};
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    height: 30px;
    min-width: 20px;
    padding: 0 5px;
    display: flex;
    background-color: transparent;
  }

  .pagination__page-active {
    background-color: ${({ theme }) => theme.colors.lightBlue};
    border-color: ${({ theme }) => theme.colors.lightBlue};
    color: ${({ theme }) => theme.colors.white};
  }

  .pagination__link,
  .pagination__next-link,
  .pagination__prev-link {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
  }

  .pagination__disabled {
    opacity: 0.5;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.m}) {
    justify-content: center;
  }
`;

export const Text = styled.p`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  margin-right: 20px;
  color: ${({ theme }) => theme.colors.deepDark};
`;
